import ColorChunk from '/opt/buildhome/repo/.dumi/theme/builtins/ColorChunk/index.tsx';
import API from '/opt/buildhome/repo/node_modules/dumi/theme-default/builtins/API/index.js';
import Badge from '/opt/buildhome/repo/node_modules/dumi/theme-default/builtins/Badge/index.js';
import CodeGroup from '/opt/buildhome/repo/node_modules/dumi/theme-default/builtins/CodeGroup/index.js';
import Container from '/opt/buildhome/repo/.dumi/theme/builtins/Container/index.tsx';
import Previewer from '/opt/buildhome/repo/.dumi/theme/builtins/Previewer/index.tsx';
import SourceCode from '/opt/buildhome/repo/node_modules/dumi/theme-default/builtins/SourceCode/index.js';
import Table from '/opt/buildhome/repo/node_modules/dumi/theme-default/builtins/Table/index.js';
import Tree from '/opt/buildhome/repo/node_modules/dumi/theme-default/builtins/Tree/index.js';
import APITable from '/opt/buildhome/repo/.dumi/theme/builtins/APITable/index.tsx';
import Audio from '/opt/buildhome/repo/.dumi/theme/builtins/Audio/index.tsx';
import ColorPalettes from '/opt/buildhome/repo/.dumi/theme/builtins/ColorPalettes/index.ts';
import ColorPaletteTool from '/opt/buildhome/repo/.dumi/theme/builtins/ColorPaletteTool/index.ts';
import ColorPaletteToolDark from '/opt/buildhome/repo/.dumi/theme/builtins/ColorPaletteToolDark/index.ts';
import ComponentMeta from '/opt/buildhome/repo/.dumi/theme/builtins/ComponentMeta/index.tsx';
import ComponentOverview from '/opt/buildhome/repo/.dumi/theme/builtins/ComponentOverview/index.tsx';
import ComponentTokenTable from '/opt/buildhome/repo/.dumi/theme/builtins/ComponentTokenTable/index.tsx';
import DemoWrapper from '/opt/buildhome/repo/.dumi/theme/builtins/DemoWrapper/index.tsx';
import IconSearch from '/opt/buildhome/repo/.dumi/theme/builtins/IconSearch/index.tsx';
import ImagePreview from '/opt/buildhome/repo/.dumi/theme/builtins/ImagePreview/index.tsx';
import InlinePopover from '/opt/buildhome/repo/.dumi/theme/builtins/InlinePopover/index.tsx';
import InstallDependencies from '/opt/buildhome/repo/.dumi/theme/builtins/InstallDependencies/index.tsx';
import LocaleLink from '/opt/buildhome/repo/.dumi/theme/builtins/LocaleLink/index.tsx';
import Palette from '/opt/buildhome/repo/.dumi/theme/builtins/Palette/index.ts';
import ResourceCards from '/opt/buildhome/repo/.dumi/theme/builtins/ResourceCards/index.tsx';
import Sandpack from '/opt/buildhome/repo/.dumi/theme/builtins/Sandpack/index.tsx';
import TokenCompare from '/opt/buildhome/repo/.dumi/theme/builtins/TokenCompare/index.tsx';
import TokenTable from '/opt/buildhome/repo/.dumi/theme/builtins/TokenTable/index.tsx';
import VideoPlayer from '/opt/buildhome/repo/.dumi/theme/builtins/VideoPlayer/index.tsx';
import { DumiDemo } from 'dumi';
import { DumiDemoGrid } from 'dumi';
import { Link } from 'dumi';

import LoadingComponent from '@@/dumi/theme/loading';
import React, { Suspense } from 'react';
import { DumiPage, useTabMeta, useRouteMeta } from 'dumi';

function DumiMarkdownInner() {
  const { texts: $$contentTexts } = useRouteMeta();

  return <><div className="markdown"><h2 id="use"><LocaleLink aria-hidden="true" tabIndex="-1" href="#use" sourceType="a"><span className="icon icon-link" /></LocaleLink>{"Use"}</h2><p>{$$contentTexts[0].value}<code>{$$contentTexts[1].value}</code>{$$contentTexts[2].value}<code>{$$contentTexts[3].value}</code>{$$contentTexts[4].value}<code>{$$contentTexts[5].value}</code>{$$contentTexts[6].value}<code>{$$contentTexts[7].value}</code>{$$contentTexts[8].value}</p><p>{$$contentTexts[9].value}<code>{$$contentTexts[10].value}</code>{$$contentTexts[11].value}<code>{$$contentTexts[12].value}</code>{$$contentTexts[13].value}</p><SourceCode lang="diff">{$$contentTexts[14].value}</SourceCode><h2 id="examples"><LocaleLink aria-hidden="true" tabIndex="-1" href="#examples" sourceType="a"><span className="icon icon-link" /></LocaleLink>{"Examples"}</h2></div><DumiDemo {...{
  "demo": {
    "id": "x-provider-demo-use"
  },
  "previewerProps": {
    "background": "grey",
    "title": "Use",
    "filename": "components/x-provider/demo/use.tsx",
    "pkgDependencyList": {
      "@ant-design/tools": "^18.0.2",
      "@ant-design/v5-patch-for-react-19": "^1.0.3",
      "@antv/gpt-vis": "^0.4.1",
      "@biomejs/biome": "^1.9.0",
      "@codecov/webpack-plugin": "^1.4.0",
      "@codesandbox/sandpack-react": "^2.19.8",
      "@emotion/react": "^11.13.5",
      "@emotion/server": "^11.11.0",
      "@happy-dom/jest-environment": "^17.4.3",
      "@ianvs/prettier-plugin-sort-imports": "^4.3.1",
      "@madccc/duplicate-package-checker-webpack-plugin": "^1.0.0",
      "@microflash/rehype-figure": "^2.1.1",
      "@npmcli/run-script": "^9.0.1",
      "@octokit/rest": "^21.0.2",
      "@petercatai/assistant": "^2.0.13",
      "@qixian.cs/github-contributors-list": "^2.0.2",
      "@rc-component/father-plugin": "^2.0.4",
      "@rc-component/np": "^1.0.3",
      "@rc-component/trigger": "^2.2.3",
      "@size-limit/file": "^11.1.5",
      "@stackblitz/sdk": "^1.11.0",
      "@testing-library/dom": "^10.4.0",
      "@testing-library/jest-dom": "^6.5.0",
      "@testing-library/react": "^16.0.1",
      "@testing-library/user-event": "^14.5.2",
      "@types/adm-zip": "^0.5.5",
      "@types/ali-oss": "^6.16.11",
      "@types/cli-progress": "^3.11.6",
      "@types/fs-extra": "^11.0.4",
      "@types/gtag.js": "^0.0.20",
      "@types/http-server": "^0.12.4",
      "@types/inquirer": "^9.0.7",
      "@types/isomorphic-fetch": "^0.0.39",
      "@types/jest": "^29.5.13",
      "@types/jest-axe": "^3.5.9",
      "@types/jest-environment-puppeteer": "^5.0.6",
      "@types/jest-image-snapshot": "^6.4.0",
      "@types/jquery": "^3.5.30",
      "@types/jsdom": "^21.1.7",
      "@types/lodash": "^4.17.7",
      "@types/markdown-it": "^14.1.2",
      "@types/minimist": "^1.2.5",
      "@types/node": "^22.5.5",
      "@types/ora": "^3.2.0",
      "@types/pixelmatch": "^5.2.6",
      "@types/pngjs": "^6.0.5",
      "@types/prismjs": "^1.26.4",
      "@types/progress": "^2.0.7",
      "@types/qs": "^6.9.16",
      "@types/react": "^19.0.2",
      "@types/react-copy-to-clipboard": "^5.0.7",
      "@types/react-dom": "^19.0.2",
      "@types/react-highlight-words": "^0.20.0",
      "@types/react-resizable": "^3.0.8",
      "@types/semver": "^7.5.8",
      "@types/spinnies": "^0.5.3",
      "@types/tar": "^6.1.13",
      "@types/throttle-debounce": "^5.0.2",
      "@types/warning": "^3.0.3",
      "@umijs/fabric": "^4.0.1",
      "adm-zip": "^0.5.16",
      "ali-oss": "^6.21.0",
      "antd": "^5.22.7",
      "antd-style": "^3.6.3",
      "antd-token-previewer": "^2.0.8",
      "axios": "^1.7.7",
      "browserslist": "^4.23.3",
      "browserslist-to-esbuild": "^2.1.1",
      "chalk": "^5.4.1",
      "cheerio": "^1.0.0",
      "circular-dependency-plugin": "^5.2.2",
      "cli-progress": "^3.12.0",
      "copy-to-clipboard": "^3.3.3",
      "cross-env": "^7.0.3",
      "cross-fetch": "^4.0.0",
      "crypto": "^1.0.1",
      "dayjs": "^1.11.13",
      "dekko": "^0.2.1",
      "dumi": "^2.4.17",
      "dumi-plugin-color-chunk": "^2.1.0",
      "esbuild-loader": "^4.2.2",
      "fast-glob": "^3.3.2",
      "father": "4.5.2",
      "fetch-jsonp": "^1.3.0",
      "fs-extra": "^11.2.0",
      "gh-pages": "^6.1.1",
      "glob": "^11.0.0",
      "happy-dom": "^17.4.3",
      "html2sketch": "^1.0.2",
      "http-server": "^14.1.1",
      "husky": "^9.1.6",
      "identity-obj-proxy": "^3.0.0",
      "immer": "^10.1.1",
      "inquirer": "^12.1.0",
      "is-ci": "^4.1.0",
      "isomorphic-fetch": "^3.0.0",
      "jest": "^29.7.0",
      "jest-axe": "^10.0.0",
      "jest-canvas-mock": "^2.5.2",
      "jest-environment-node": "^29.7.0",
      "jest-image-snapshot": "^6.4.0",
      "jest-puppeteer": "^11.0.0",
      "jquery": "^3.7.1",
      "jsdom": "^26.0.0",
      "jsonml-to-react-element": "^1.1.11",
      "jsonml.js": "^0.1.0",
      "lint-staged": "^15.2.10",
      "lodash": "^4.17.21",
      "lottie-web": "^5.12.2",
      "lunar-typescript": "^1.7.5",
      "lz-string": "^1.5.0",
      "markdown-it": "^14.1.0",
      "minimist": "^1.2.8",
      "mockdate": "^3.0.5",
      "node-fetch": "^3.3.2",
      "node-notifier": "^10.0.1",
      "open": "^10.1.0",
      "ora": "^8.1.0",
      "pixelmatch": "^7.1.0",
      "pngjs": "^7.0.0",
      "prettier": "^3.3.3",
      "prettier-plugin-jsdoc": "^1.3.0",
      "pretty-format": "^29.7.0",
      "prismjs": "^1.29.0",
      "puppeteer": "^24.0.0",
      "qs": "^6.13.0",
      "rc-drawer": "^8.0.0",
      "rc-footer": "^0.6.8",
      "rc-resize-observer": "^1.4.0",
      "rc-virtual-list": "^3.14.5",
      "react": "^19.0.0",
      "react-copy-to-clipboard": "^5.1.0",
      "react-countup": "^6.5.3",
      "react-dom": "^19.0.0",
      "react-highlight-words": "^0.20.0",
      "react-infinite-scroll-component": "^6.1.0",
      "react-intersection-observer": "^9.13.1",
      "react-intl": "7.1.6",
      "react-resizable": "^3.0.5",
      "react-router-dom": "^7.0.1",
      "react-sticky-box": "^2.0.5",
      "regenerator-runtime": "^0.14.1",
      "rehype-stringify": "^10.0.0",
      "remark": "^15.0.1",
      "remark-cli": "^12.0.1",
      "remark-gfm": "^4.0.0",
      "remark-lint": "^10.0.0",
      "remark-lint-no-undefined-references": "^5.0.0",
      "remark-preset-lint-recommended": "^7.0.0",
      "remark-rehype": "^11.1.0",
      "scroll-into-view-if-needed": "^3.1.0",
      "semver": "^7.6.3",
      "sharp": "^0.33.5",
      "simple-git": "^3.26.0",
      "size-limit": "^11.1.5",
      "spinnies": "^0.5.1",
      "stylelint": "^16.9.0",
      "stylelint-config-rational-order": "^0.1.2",
      "stylelint-config-standard": "^37.0.0",
      "stylelint-prettier": "^5.0.2",
      "sylvanas": "^0.6.1",
      "tar": "^7.4.3",
      "tar-fs": "^3.0.6",
      "terser": "^5.32.0",
      "tsx": "^4.19.1",
      "typedoc": "^0.28.0",
      "typescript": "~5.8.2",
      "vanilla-jsoneditor": "^3.0.0",
      "vanilla-tilt": "^1.8.1",
      "web-streams-polyfill": "^4.0.0",
      "webpack": "^5.94.0",
      "webpack-bundle-analyzer": "^4.10.2",
      "@ant-design/colors": "^7.1.0",
      "@ant-design/cssinjs": "^1.21.1",
      "@ant-design/cssinjs-utils": "^1.1.0",
      "@ant-design/fast-color": "^2.0.6",
      "@ant-design/icons": "^5.4.0",
      "@babel/runtime": "^7.25.6",
      "classnames": "^2.5.1",
      "rc-motion": "^2.9.2",
      "rc-util": "^5.43.0"
    },
    "jsx": "import {\n  Bubble,\n  Conversations,\n  Prompts,\n  Sender,\n  Suggestion,\n  ThoughtChain,\n  XProvider,\n} from '@ant-design/x';\nimport { Card, Divider, Flex, Radio, Typography } from 'antd';\nimport React from 'react';\nimport {\n  AlipayCircleOutlined,\n  BulbOutlined,\n  CheckCircleOutlined,\n  GithubOutlined,\n  LoadingOutlined,\n  SmileOutlined,\n  UserOutlined,\n} from '@ant-design/icons';\nexport default () => {\n  const [value, setValue] = React.useState('');\n  const [direction, setDirection] = React.useState('ltr');\n  return (\n    <>\n      <Flex\n        gap={12}\n        style={{\n          marginBottom: 16,\n        }}\n        align=\"center\"\n      >\n        <Typography.Text>Direction:</Typography.Text>\n        <Radio.Group value={direction} onChange={(e) => setDirection(e.target.value)}>\n          <Radio.Button value=\"ltr\">LTR</Radio.Button>\n          <Radio.Button value=\"rtl\">RTL</Radio.Button>\n        </Radio.Group>\n      </Flex>\n      <Card>\n        <XProvider direction={direction}>\n          <Flex\n            style={{\n              height: 500,\n            }}\n            gap={12}\n          >\n            <Conversations\n              style={{\n                width: 200,\n              }}\n              defaultActiveKey=\"1\"\n              items={[\n                {\n                  key: '1',\n                  label: 'Conversation - 1',\n                  icon: <GithubOutlined />,\n                },\n                {\n                  key: '2',\n                  label: 'Conversation - 2',\n                  icon: <AlipayCircleOutlined />,\n                },\n              ]}\n            />\n            <Divider\n              type=\"vertical\"\n              style={{\n                height: '100%',\n              }}\n            />\n            <Flex\n              vertical\n              style={{\n                flex: 1,\n              }}\n              gap={8}\n            >\n              <Bubble.List\n                style={{\n                  flex: 1,\n                }}\n                items={[\n                  {\n                    key: '1',\n                    placement: 'end',\n                    content: 'Hello Ant Design X!',\n                    avatar: {\n                      icon: <UserOutlined />,\n                    },\n                  },\n                  {\n                    key: '2',\n                    content: 'Hello World!',\n                  },\n                  {\n                    key: '2',\n                    content: '',\n                    loading: true,\n                  },\n                ]}\n              />\n              <Prompts\n                items={[\n                  {\n                    key: '1',\n                    icon: (\n                      <BulbOutlined\n                        style={{\n                          color: '#FFD700',\n                        }}\n                      />\n                    ),\n                    label: 'Ignite Your Creativity',\n                  },\n                  {\n                    key: '2',\n                    icon: (\n                      <SmileOutlined\n                        style={{\n                          color: '#52C41A',\n                        }}\n                      />\n                    ),\n                    label: 'Tell me a Joke',\n                  },\n                ]}\n              />\n              <Suggestion\n                items={[\n                  {\n                    label: 'Write a report',\n                    value: 'report',\n                  },\n                ]}\n              >\n                {({ onTrigger, onKeyDown }) => {\n                  return (\n                    <Sender\n                      value={value}\n                      onChange={(nextVal) => {\n                        if (nextVal === '/') {\n                          onTrigger();\n                        } else if (!nextVal) {\n                          onTrigger(false);\n                        }\n                        setValue(nextVal);\n                      }}\n                      onKeyDown={onKeyDown}\n                      placeholder='Type \"/\" to trigger suggestion'\n                    />\n                  );\n                }}\n              </Suggestion>\n            </Flex>\n            <Divider\n              type=\"vertical\"\n              style={{\n                height: '100%',\n              }}\n            />\n            <ThoughtChain\n              style={{\n                width: 200,\n              }}\n              items={[\n                {\n                  title: 'Hello Ant Design X!',\n                  status: 'success',\n                  description: 'status: success',\n                  icon: <CheckCircleOutlined />,\n                  content: 'Ant Design X help you build AI chat/platform app as ready-to-use 📦.',\n                },\n                {\n                  title: 'Hello World!',\n                  status: 'success',\n                  description: 'status: success',\n                  icon: <CheckCircleOutlined />,\n                },\n                {\n                  title: 'Pending...',\n                  status: 'pending',\n                  description: 'status: pending',\n                  icon: <LoadingOutlined />,\n                },\n              ]}\n            />\n          </Flex>\n        </XProvider>\n      </Card>\n    </>\n  );\n};\n",
    "description": "<p>Usage.</p>"
  }
}} /><div className="markdown"><h2 id="api"><LocaleLink aria-hidden="true" tabIndex="-1" href="#api" sourceType="a"><span className="icon icon-link" /></LocaleLink>{"API"}</h2><p><code>{$$contentTexts[15].value}</code>{$$contentTexts[16].value}<code>{$$contentTexts[17].value}</code>{$$contentTexts[18].value}<code>{$$contentTexts[19].value}</code>{$$contentTexts[20].value}<LocaleLink href="https://ant-design.antgroup.com/components/config-provider-cn#api" sourceType="a">{$$contentTexts[21].value}</LocaleLink></p><h3 id="component-config"><LocaleLink aria-hidden="true" tabIndex="-1" href="#component-config" sourceType="a"><span className="icon icon-link" /></LocaleLink>{"Component Config"}</h3><Table className="component-api-table"><thead><tr><th>{$$contentTexts[22].value}</th><th>{$$contentTexts[23].value}</th><th>{$$contentTexts[24].value}</th><th>{$$contentTexts[25].value}</th><th>{$$contentTexts[26].value}</th></tr></thead><tbody><tr><td>{$$contentTexts[27].value}</td><td>{$$contentTexts[28].value}</td><td>{$$contentTexts[29].value}</td><td>{$$contentTexts[30].value}</td><td /></tr><tr><td>{$$contentTexts[31].value}</td><td>{$$contentTexts[32].value}</td><td>{$$contentTexts[33].value}</td><td>{$$contentTexts[34].value}</td><td /></tr><tr><td>{$$contentTexts[35].value}</td><td>{$$contentTexts[36].value}</td><td>{$$contentTexts[37].value}</td><td>{$$contentTexts[38].value}</td><td /></tr><tr><td>{$$contentTexts[39].value}</td><td>{$$contentTexts[40].value}</td><td>{$$contentTexts[41].value}</td><td>{$$contentTexts[42].value}</td><td /></tr><tr><td>{$$contentTexts[43].value}</td><td>{$$contentTexts[44].value}</td><td>{$$contentTexts[45].value}</td><td>{$$contentTexts[46].value}</td><td /></tr><tr><td>{$$contentTexts[47].value}</td><td>{$$contentTexts[48].value}</td><td>{$$contentTexts[49].value}</td><td>{$$contentTexts[50].value}</td><td /></tr></tbody></Table></div></>;
}

// export named function for fastRefresh
// ref: https://github.com/pmmmwh/react-refresh-webpack-plugin/blob/main/docs/TROUBLESHOOTING.md#edits-always-lead-to-full-reload
function DumiMarkdownContent() {
  // wrap suspense for catch async meta data
  return <DumiPage><Suspense fallback={<LoadingComponent />}><DumiMarkdownInner /></Suspense></DumiPage>;
}

export default DumiMarkdownContent;